import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Loading from 'shared/components/Loading';

import {
  me
} from 'shared/actions/userActions';

const Auth = props => {
  const {
    children
  } = props;

  const [loading, setLoading] = useState(true);
  const loggedIn = useSelector(state => state.userReducer.loggedIn);
  const dispatch = useDispatch();

  const auth = async () => {
    try {
      await dispatch(me());

    } catch(err) {
      console.error(err);
    }

    setLoading(false);
  }

  useEffect(() => auth(), []);

  if (loading) {
    return <Loading />;
  }

  if (!loggedIn) {
    return <Redirect to="/login" />;
  }

  return <div>{children}</div>;
}

export default Auth;
